var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'has-header': _vm.showHeader, 'no-header': !_vm.showHeader },attrs:{"id":"app"}},[(_vm.showHeader)?_c('Header'):_vm._e(),_c('LeftMenu',{ref:"LeftMenu"}),_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []

export { render, staticRenderFns }